// src/com/dc_veh_ban_state/DcVehBanStateDict.js
// DbdbTap 2024-10-02 10:15:19
import { InputType, TableColumnType } from "../../value/AppConst";
import IsValid from "../../value/IsValid";

const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    vehInfoSeq : {
		id: 'vehInfoSeq', label: '차량',
		type: InputType.select, required: true, toAdd: true, toEdit: true,
        labelKey: 'vehPlates',
        getOptionLabel: (option) => option.vehPlates,
	}, // int(11)
    vehBanLastingFlag : {
		id: 'vehBanLastingFlag', label: '영구금지',
		type: InputType.checkbox, required: false, toAdd: true, toEdit: true,
		trueValue: 'Y', falseValue: 'N',
	}, // enum('N','Y')
    vehBanStartTime : {
		id: 'vehBanStartTime', label: '금지시작일',
		type: InputType.date, required: true, toAdd: true, toEdit: true,
	}, // timestamp
    vehBanDays : {
		id: 'vehBanDays', label: '금지기간(일)',
		type: InputType.number, required: false, toAdd: true, toEdit: true,
	}, // int(3)
    
};

/**
 * DC_VEH_BAN_STATE React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-10-02 10:15:19 using DbdbTap
 */
export const DcVehBanStateDictionary = {
    inputMap: Dict,
    errorTitle: {
        Add: '배차금지정보 등록 오류',
        Edit: '배차금지정보 수정 오류',
        Remove: '배차금지정보 삭제 오류',
        Get: '배차금지정보 조회 오류',
    },
};
